import React from 'react';
import { countyList } from '../SharedConstants';

export const CountySelect = ({ id, value, selectedState, onChange, required = false, disabled = false }) => {
    return (
        <select
            id={`${id}`}
            onChange={onChange}
            value={value}
            required={required}
            disabled={disabled}
        >
            <option value=''>Select</option>
            {countyList
                .filter((ac) => ac.state === selectedState)
                .map((c) => {
                    return (
                        <option
                            key={c.county + '_' + c.state}
                            value={c.county}
                        >
                            {c.county}
                        </option>
                    );
                })}
        </select>
    );
};
